import React, { Suspense, useEffect } from "react";
import { checkAppVersion } from "./utils/checkAppVersion";
import "./App.css";
import { AuthProvider } from "./context/AuthProvider";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Login from "./ui/pages/Login";
import Home from "./ui/pages/Home";
import { useCountries } from "./hooks/useCountries";
import CookieBot from 'react-cookiebot/lib/CookieBot';
import { PrivateRoute } from "./context/PrivateRoute";
import ChangePassword from "./ui/pages/Login/components/ChangePassword/ChangePassword";
import UiProvider from "./context/UiContext";

const domainGroupId = "a417f6b6-80c7-4e1c-99f0-dafe7a93e54f";

function App() {
  const { countries } = useCountries();

  function clearStorages() {
    try {
      localStorage.clear();
    } catch (e) {
      const msg = (e && (e as any).message) ? (e as any).message : String(e);
      Promise.reject(new Error('Failed to clear localStorage: ' + msg));
    }
    try {
      sessionStorage.clear();
    } catch (e) {
      const msg = (e && (e as any).message) ? (e as any).message : String(e);
      Promise.reject(new Error('Failed to clear sessionStorage: ' + msg));
    }
  }

  function clearCaches() {
    if ('caches' in window) {
      caches.keys().then(keys => {
        keys.forEach(k => caches.delete(k));
      });
    }
  }

  function unregisterServiceWorkers() {
    if (navigator.serviceWorker) {
      navigator.serviceWorker.getRegistrations().then(regs => {
        regs.forEach(r => r.unregister());
      });
    }
  }

  useEffect(() => {
    checkAppVersion();
  }, []);

  return (
    <AuthProvider>
      <Suspense fallback="" >
        <BrowserRouter>
          <CookieBot domainGroupId={domainGroupId} />
          <Container
            className="App"
            fluid
          >
            <UiProvider>
              <Routes>
                <Route path="/" element={<Login countries={countries} />} />
                <Route path="*" element={<Login countries={countries} />} />
                <Route path="/login" element={<Login countries={countries} />} />
                <Route path="/changepassword" element={<ChangePassword countries={countries} />} />
                <Route path="/home" element={<PrivateRoute path="/home"> <Home /> </PrivateRoute>} />
              </Routes>
            </UiProvider>
          </Container>
        </BrowserRouter>
      </Suspense>
    </AuthProvider>
  );
}

export default App;
